<main class="page-shell auth-page">
  <section class="auth-shell">
    <aside class="auth-visual">
      <div class="visual-header">
        <div class="brand">
          <strong>javaStreams</strong>
          <span>Java Stream API Practice</span>
        </div>
        <div class="status-pill">Live</div>
      </div>
      <h1>Practice streams like a production engineer.</h1>
      <p>
        Solve curated Stream API challenges, iterate with instant feedback, and build
        a real-world Java workflow.
      </p>
      <div class="visual-metrics">
        <div>
          <strong>500+</strong>
          <span>Challenges</span>
        </div>
        <div>
          <strong>12 ms</strong>
          <span>Avg run</span>
        </div>
        <div>
          <strong>Ranked</strong>
          <span>Leaderboards</span>
        </div>
      </div>
      <div class="visual-chips">
        <span>JWT</span>
        <span>Supabase</span>
        <span>2FA Ready</span>
        <span>Rate Limit</span>
      </div>
      <div class="visual-steps">
        <div class="step">
          <span class="step-index">01</span>
          <div>
            <strong>Verify email</strong>
            <span>Secure your first login.</span>
          </div>
        </div>
        <div class="step">
          <span class="step-index">02</span>
          <div>
            <strong>Sync profile</strong>
            <span>Unlock streaks and XP.</span>
          </div>
        </div>
        <div class="step">
          <span class="step-index">03</span>
          <div>
            <strong>Enter workspace</strong>
            <span>Run, debug, repeat.</span>
          </div>
        </div>
      </div>
      <div class="visual-terminal">
        <div class="terminal-bar">
          <span class="dot red"></span>
          <span class="dot amber"></span>
          <span class="dot green"></span>
          <span class="terminal-title">AuthFlow.ts</span>
        </div>
        <pre class="code-font" ngNonBindable>
<code>const user = await auth.signIn(&#123;
  email,
  password
&#125;);

router.push("/dashboard");</code></pre>
      </div>
    </aside>

    <section class="card auth-card">
      <div class="tabs">
        <button type="button" class="tab" [class.active]="mode === 'login'" (click)="setMode('login')">Login</button>
        <button type="button" class="tab" [class.active]="mode === 'signup'" (click)="setMode('signup')">Sign up</button>
      </div>

      <h2>
        {{ mode === "login" ? "Welcome back" : mode === "signup" ? "Create your javaStreams account" : "Reset your password" }}
      </h2>
      <p class="hint">
        {{
          mode === "forgot"
            ? "Enter your email to receive a reset link."
            : "Continue with email. Email sign-up requires verification."
        }}
      </p>

      <form *ngIf="mode === 'login'" [formGroup]="loginForm" (ngSubmit)="submitLogin()" class="form">
        <label>
          Email
          <input type="email" formControlName="email" placeholder="you@example.com" />
        </label>
        <label>
          Password
          <input type="password" formControlName="password" placeholder="Password" />
        </label>
        <button type="submit" class="btn-primary" [disabled]="isBusy">Login</button>
        <button type="button" class="link-btn" (click)="setMode('forgot')" [disabled]="isBusy">Forgot password?</button>
      </form>

      <form *ngIf="mode === 'signup'" [formGroup]="signupForm" (ngSubmit)="submitSignup()" class="form">
        <label>
          Name
          <input type="text" formControlName="name" placeholder="Your name" />
        </label>
        <label>
          Email
          <input type="email" formControlName="email" placeholder="you@example.com" />
        </label>
        <label>
          Phone (optional)
          <input type="text" formControlName="phone" placeholder="+123456789" />
        </label>
        <label>
          Password
          <input type="password" formControlName="password" placeholder="Minimum 6 characters" />
        </label>
        <button type="submit" class="btn-primary" [disabled]="isBusy">Create account</button>
      </form>

      <form *ngIf="mode === 'forgot'" [formGroup]="forgotForm" (ngSubmit)="submitForgot()" class="form">
        <label>
          Email
          <input type="email" formControlName="email" placeholder="you@example.com" />
        </label>
        <button type="submit" class="btn-primary" [disabled]="isBusy">Send reset link</button>
        <button type="button" class="link-btn" (click)="setMode('login')" [disabled]="isBusy">Back to login</button>
      </form>

      <p class="message" *ngIf="message">{{ message }}</p>
      <p class="error" *ngIf="error">{{ error }}</p>
      <p class="error" *ngIf="startupError()">{{ startupError() }}</p>
      <a routerLink="/" class="back">Back to home</a>
    </section>
  </section>
</main>
